import { useEffect, useState } from 'react';
import useLocalStorage from '@hooks/useLocalStorage';
import { constant } from '@config/BaseSetting';
import { getPartnersFilterListAPI } from '@services/WebApiService';

export default function useDistributorFilterHook(externalValue) {
  const [accessTokenSet] = useLocalStorage(constant.ACCESS_TOKEN_STORAGE);
  const [distributorFilterState, setDistributorFilterState] = useState({
    forceUpdate: false,
    searchState: '',
    selectedPartner: '',
  });
  const [distributorsFilterList, setDistributorsFilterList] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handlePartnerFilterSearch = async (search) => {
    try {
      setIsLoading(true);
      const response = await getPartnersFilterListAPI({
        accessToken: accessTokenSet,
        reset: true,
        searchTerm: search,
        isOnlyParent: true,
      });
      if (response?.data?.data) {
        setDistributorsFilterList(response.data.data);
      }
    } catch (e) {
      // Optionally handle error
    } finally {
      setIsLoading(false);
    }
  };

  const responseConverter = (data) =>
    data.map((item) => ({
      id: item?.id,
      value: item?.id,
      title: `${item?.id} - ${item.partnerName}`,
    }));

  const resetPartnerFilter = () => {
    setDistributorFilterState({
      forceUpdate: !distributorFilterState.forceUpdate,
      searchState: '',
      selectedPartner: '',
    });
    handlePartnerFilterSearch('');
  };

  const UpdateFilters = (value, properties) => {
    setDistributorFilterState((prev) => {
      const newState = { ...prev };
      properties.forEach((property) => {
        newState[property] = value;
      });
      return newState;
    });
  };

  useEffect(() => {
    if (
      distributorFilterState.searchState.length === 0 ||
      distributorFilterState.searchState.length > 2
    ) {
      handlePartnerFilterSearch(distributorFilterState.searchState);
    }
  }, [distributorFilterState.searchState]);

  useEffect(() => {
    setPartnerList(responseConverter(distributorsFilterList));
  }, [distributorsFilterList]);

  useEffect(() => {
    if (externalValue === distributorFilterState.selectedPartner) return;
    UpdateFilters(externalValue || '', ['selectedPartner']);
  }, [externalValue]);

  return {
    distributorFilterState,
    resetPartnerFilter,
    UpdateFilters,
    partnerList,
    isLoading,
  };
}
